import React from "react";
import * as Errors from "@morningtrain/react-errors";
import {inject} from '@morningtrain/react-decorators';

@inject(["auth"])
export default class BaseTemplate extends React.Component {

    render() {
        return (
            <React.Fragment>
                <div className={"content"}>
                    <div className={"content-inner"}>
                        <Errors.Boundary>
                            {this.props.children}
                        </Errors.Boundary>
                    </div>
                </div>
            </React.Fragment>
        );
    }

}
